import { render, staticRenderFns } from "./centerLeft3.vue?vue&type=template&id=9023e944&scoped=true&"
import script from "./centerLeft3.vue?vue&type=script&lang=js&"
export * from "./centerLeft3.vue?vue&type=script&lang=js&"
import style0 from "./centerLeft3.vue?vue&type=style&index=0&id=9023e944&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9023e944",
  null
  
)

export default component.exports